export default {
  desktop: {
    ThemeImporter: () => import(/* webpackChunkName: "formulabih-themeWrap" */'./ThemeImporter'),
  },
  mobile: {
    ThemeImporter: () => import(/* webpackChunkName: "formulabih-themeWrap" */'./ThemeImporter'),
  },
};
